export default {
    REQUESTING: 'REQUESTING',
    STATIC: 'STATIC',
};
